<template>
  <!-- 탭 :: 약품정보&설문조사 영역-->
  <div class="main-tab-wrap">
    <div />

    <div class="tab-nav">
      <!-- single-type -->
      <button
        v-if="isLiveOptionActivity && isSurveyActivity"
        :class="tabType == 1? 'active' : ''" @click="getMainViews(1)"
      >
        전체
      </button>
      <button
        v-if="isLiveOptionActivity"
        :class="tabType == 2? 'active' : ''" @click="getMainViews(2)"
      >
        약품정보
      </button>
      <button
        v-if="isSurveyActivity"
        :class="tabType == 3? 'active' : ''" @click="getMainViews(3)"
      >
        설문조사
      </button>
    </div>
    <div class="tab-contents">
      <div v-if="mainViews.length == 0"
           class="tab-contents-item"
           :style="`minHeight: ${Math.ceil(maxLength / 2) * 26}px; display: block;`"
      >
        <ul>
          <li class="empty-type">
            <p>등록된 컨텐츠가 없습니다.</p>
          </li>
        </ul>
      </div>
      <div v-else
           class="tab-contents-item"
           :style="`minHeight: ${Math.ceil(maxLength / 2) * 26}px; display: block;`"
      >
        <ul>
          <li
            v-for="item in mainViews"
            :key="`${item.contentType} + ${item.liveInfoId}`"
            :class="item.contentType === 1 ? 'read-type' : 'badge-type'"
          >
            <a
              @click="handleClick(item)"
            >
              <span
                v-if="item.contentType === 3"
                class="badge"
              >설문</span>
              <span class="text">{{ item.title }}</span>
            </a>
          </li>
        </ul>
      </div>
    </div>
    <!-- //탭 :: 약품정보&설문조사 영역-->

  </div>
</template>

<script>
// import axios from '@axios'
import { mapGetters } from 'vuex'
import { SNT } from '@/core/global/global-enums'

export default {
  data() {
    return {
      mainViews: [],
      tabType: 1, // 1 전체, 2 약품, 3 설문
      maxLength: 0, // 전체 높이로 고정용
    }
  },
  computed: {
    ...mapGetters({
      isLiveOptionActivity: 'infoData/getIsLiveOptionActivity',
      isSurveyActivity: 'infoData/getIsSurveyActivity',
      medicalDept: 'infoData/getMedicalDept',
      region: 'infoData/getRegion',
      drugInfos: 'infoData/getDrugInfos',
      surveys: 'infoData/getSurveys',
    })
  },

  mounted() {
    // 전체 높이 저장 (최대 30)
    this.maxLength = [...this.drugInfos, ...this.surveys].length
    if (this.maxLength > 30) {
      this.maxLength = 30
    }

    // 진료실 옵션 활성화에 따라 default 지정
    if (this.isLiveOptionActivity && this.isSurveyActivity) {
      this.getMainViews(1)
    } else if (this.isLiveOptionActivity) {
      this.getMainViews(2)
    } else if (this.isSurveyActivity) {
      this.getMainViews(3)
    }
  },
  methods: {
    getMainViews(val) {
      this.tabType = val

      // 탭 구분에 따라 글 병합
      if (this.tabType === 1) {
        this.mainViews = [...this.drugInfos, ...this.surveys]
      } else if (this.tabType === 2) {
        this.mainViews = [...this.drugInfos]
      } else if (this.tabType === 3) {
        this.mainViews = [...this.surveys]
      }

      // 상단 고정 항목과 비고정 항목 분리
      const sortedTopFixeds = this.mainViews.filter(x => x.mainTopFixLevel !== undefined)
      const shuffledNonFixeds = this.mainViews.filter(x => x.mainTopFixLevel === undefined).sort(() => Math.random() - 0.5) // 비고정 항목이 섞일 수 있도록 한번 랜덤정렬

      const unit = 100000
      this.mainViews = [...sortedTopFixeds, ...shuffledNonFixeds]
        // 상단고정 기반 상위 30개 컨텐츠 추출
        .slice(0, 30)
        // 정렬 번호 부여 (컨텐츠 유형, 상단고정, 이외 랜덤)
        .map((item) => ({
          ...item,
          sortOrder: ((item.contentType * (unit * unit))
          + ((item.mainTopFixLevel == null ? (unit + Math.random()) : item.mainTopFixLevel))
          )
        }
        ))
        // 정렬 수행
        .sort((a, b) => a.sortOrder - b.sortOrder)
    },

    handleClick(content) {
      switch (content.contentType) {
        case 1:
          this.handleDrugInfoClick(content.liveInfoId)
          break
        case 3:
          this.handleSurveyClick(content.liveInfoId)
          break
        default:
          break
      }
    },
    handleDrugInfoClick(contentId) {
      this.$emit('open-drug-info', contentId, SNT.A.Service_컨텐츠__약품정보, SNT.B.Position_닥터인포__메인____Body____홈__컨텐츠목록_1__약품정보, SNT.C.State_Action__클릭_컨텐츠)
    },
    handleSurveyClick(contentId) {
      this.$emit('open-survey', contentId, SNT.A.Service_컨텐츠__설문조사, SNT.B.Position_닥터인포__메인____Body____홈__컨텐츠목록_1__설문조사, SNT.C.State_Action__클릭_컨텐츠)
    },
  }
}
</script>
